export { default } from './SkeletonFeaturedDestinationsMobile';
